import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { EditDeviceModelComponent } from '../edit-device-model/edit-device-model.component';
import { ToastrService } from 'ngx-toastr';

import { UserService } from 'src/app/shared/services/user.service';
import { ApService } from 'src/app/shared/services/ap.service';
import { TopnavbarService } from 'src/app/shared/services/topnavbar.service';
import { FirmwareService } from 'src/app/shared/services/firmware.service';

import { FirmwareUpdateModelComponent } from '../firmware-update-model/firmware-update-model.component';
import { Subscription } from 'rxjs';
import { UserConstant } from 'src/app/shared/constants/user-constant';
import { BaseLicensesTypes } from 'src/app/shared/model/template';

import { SubcriberInfoModalComponent } from '../subcriber-info-modal/subcriber-info-modal.component';

import { DeviceMonitorDataService } from './device-monitor-data.service';
import { buildMonitorTabs, childTabs, MonitorTab, MonitorTabId, resolveMonitorPath } from './tabs/device-monitor-tabs';

@Component({
  selector: 'app-device-monitor',
  templateUrl: './device-monitor.component.html',
  styleUrls: ['./device-monitor.component.scss']
})
export class DeviceMonitorComponent implements OnInit, OnDestroy {
  private pageAvailable: boolean = true;
  orgId: any;
  org: any;
  device_id: any;
  device: any;
  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = ['name', 'mac', 'domain', 'location', 'model', 'firmware', 'baseLicense', 'createdAt', 'upTime', 'lastSeen', 'Status', 'Action'];
  lan1_status = false;
  lan2_status = false;
  firmwareList = [];
  firmware = null;
  role: any;
  ras: boolean = false;

  private loadOrganizationSubscription!: Subscription;
  private loadDataDeviceSubscription!: Subscription;
  private loadDataFirmwareSubscription!: Subscription;
  private routeQuerySubscription!: Subscription;
  private refreshTimer: any;
  mode: any;
  tabs: ReadonlyArray<MonitorTab> = [];
  sdwanTabs: ReadonlyArray<MonitorTab> = [];
  systemTabs: ReadonlyArray<MonitorTab> = [];
  selectedPath: MonitorTabId[] = [];
  tabsInitialized = false;
  private requestedTabType = '';

  rasData: any = [];

  constructor(
    public route: ActivatedRoute,
    private router: Router,
    public userService: UserService,
    public apService: ApService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private topnavbarService: TopnavbarService,
    public firmwareService: FirmwareService,
    private monitorData: DeviceMonitorDataService
  ) {
    this.dataSource = new MatTableDataSource<any>();
  }

  ngOnInit(): void {
    this.device_id = this.route.snapshot.paramMap.get('device_id');
    this.routeQuerySubscription = this.route.queryParamMap.subscribe(params => {
      this.requestedTabType = params.get('type') || '';
      if (this.tabsInitialized) {
        this.loadTab();
      }
    });
    if (this.device_id) {
      this.device_id = this.device_id.split("_").pop()
    }

    const storedUser = localStorage.getItem(UserConstant.USER);
    const parsedUser: Record<string, any> | null = storedUser
      ? JSON.parse(storedUser) as Record<string, any>
      : null;
    this.role = parsedUser?.role;

    this.loadData();
    this.refreshTimer = setInterval(() => {
      this.loadData()
    }, 480000);
  }

  setTopNavMenu() {
    if (!this.pageAvailable) return;
    this.topnavbarService.set([
      {
        "route": "/layout/organization",
        "name": "Root",
        "type": "link",
      },
      {
        "route": this.org && this.org[0] ? "/layout/organization/" + this.org[0]['_id'] : "/layout/organization",
        "name": this.org && this.org[0] ? this.org[0]['name'] : "",
        "type": "link",
      },
      {
        "route": this.org && this.org[0] ? "/layout/org/" + this.org[0]['_id'] + "/devices" : "/layout/devices",
        "name": "Devices",
        "type": "link"
      },
      {
        "route": "",
        "name": this.device && this.device[0] ? this.device[0]['name'] : "",
        "type": "text"
      },
    ])
  }

  selectTab(id: MonitorTabId): void {
    this.requestedTabType = id;
    this.loadTab();
    const rootIndex = this.tabs.findIndex(tab => tab.id === this.selectedPath[0]);
    const type = id + '-' + (rootIndex + 1);
    if (this.route.snapshot.queryParamMap.get('type') !== type) {
      this.router.navigate([], {
        relativeTo: this.route, queryParams: { type }, queryParamsHandling: 'merge',
        preserveFragment: true, replaceUrl: true
      });
    }
  }

  loadData(): void {
    if (this.loadDataDeviceSubscription) this.loadDataDeviceSubscription.unsubscribe();
    this.loadDataDeviceSubscription = this.monitorData.load(this.device_id, this.role).subscribe(snapshot => {
      this.device = snapshot.devices.map(device => ({ ...device,
        upTime: this.uptimeToStr(device.statistics ? device.statistics.upTime : device.upTime) }));
      this.dataSource.data = this.device;
      const device = this.device[0];
      this.mode = device?.templateConfig?.team?.config?.team1?.mode;
      this.orgId = device && device.orgId;
      this.loadOrganizationData();
      this.rasData = [snapshot.ras];
      this.ras = snapshot.capabilities.ras;
      this.lan1_status = snapshot.lan1Active;
      this.lan2_status = snapshot.lan2Active;
      this.tabs = device ? buildMonitorTabs(snapshot.capabilities) : [];
      this.sdwanTabs = childTabs(this.tabs, 'SDWAN');
      this.systemTabs = childTabs(this.tabs, 'device-system');
      this.loadTab();
    }, error => this.toastr.error(error?.error?.error || 'Unable to load device.'));

    if (this.loadDataFirmwareSubscription) this.loadDataFirmwareSubscription.unsubscribe();
    this.loadDataFirmwareSubscription = this.firmwareService.getFirmware().subscribe(res => {
      this.firmwareList = res;
    });
  }

  loadTab(): void {
    this.selectedPath = resolveMonitorPath(this.tabs, this.requestedTabType);
    this.tabsInitialized = this.tabs.length > 0;
  }

  loadOrganizationData() {
    if (this.orgId && this.orgId != 'pending') {
      let obj = {
        id: this.orgId
      }
      if (this.loadOrganizationSubscription) this.loadOrganizationSubscription.unsubscribe();
      this.loadOrganizationSubscription = this.userService.getOrganization(obj).subscribe(res => {
        res = res.data;
        this.org = res;
        this.setTopNavMenu()
      })
    }
  }

  uptimeToStr(input: number | null) {
    if (input == null) {
      return '-';
    }
    let day, hour, minutes, seconds, n;
    n = Math.floor(input);
    day = Math.floor(n / (24 * 3600));
    n = Math.floor(n % (24 * 3600));
    hour = Math.floor(n / 3600);
    n = Math.floor(n % 3600);
    minutes = Math.floor(n / 60);
    n = Math.floor(n % 60);
    seconds = n;
    let str = '';
    str = str + (day ? day + 'd ' : '');
    str = str + (hour ? hour + 'h ' : '');
    str = str + (minutes ? minutes + 'm ' : '');
    str = str + (seconds ? seconds + 's' : '');
    return str;

  }
  getStatus(date: string | number | Date, track: any[]) {
    if(track && track.length>0){
      // if(track[0].lastDeviceState == "alert_on"){
      //   return "on"
      // }else if(track[0].lastDeviceState == "alert_off"){
      //   return "off"
      // } else {
      //   return track[0].lastDeviceState
      // } OLD TRACK STATUS
      if(track[0].lastDeviceState === 1){
        return "on"
      }else if(track[0].lastDeviceState === 2){
        return "warn"
      } else {
        return "off"
      }

    } else {
      const time = new Date(date);
      let cdate = new Date();
      let datedifferance = cdate.getTime() - time.getTime();
      if (datedifferance > 600e3) { // greater than 10 min
        return 'off';
      } else if(datedifferance < 600e3  && datedifferance > 300e3){
        return 'warn';
      } else {
        return 'on';
      }
    }

  }

  teminalclick(element: any) {
    this.apService.createDeviceBrowseHistory(element.mac, "terminal").subscribe()
    const url = element.terminal_url;
    window.open(url, '_blank');
  }

  webclick(element: any) {
    this.apService.createDeviceBrowseHistory(element.mac, "webui").subscribe()
    const url = element.host_url;
    window.open(url, '_blank');
  }

  delete(id) {
    const deviceArray = [];
    deviceArray.push(id);
    if (confirm('Are you sure you want to delete?')) {
      this.apService.deviceDelete(deviceArray).subscribe(res => {
        this.toastr.success('Device Deleted');
      });
    }
  }

  redirect_lan1(element) {
    this.apService.createDeviceBrowseHistory(element.mac, "lan").subscribe()
    window.open(element.lan1_url, '_blank');
  }

  redirect_lan2(element) {
    this.apService.createDeviceBrowseHistory(element.mac, "lan").subscribe()
    window.open(element.lan2_url, '_blank');
  }

  resetPwd(id) {
    if (confirm('Are you sure you want to reset password?')) {
      this.apService.setDeviceCommand(id, { name: "resetPwd" }).subscribe(res => {
        this.toastr.success('Password is reset successfully.');
      });
    }
  }

  editDevice(data): void {
    const dialogRef = this.dialog.open(EditDeviceModelComponent, {
      disableClose: true,
      width: '700px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadData();
    });
  }

  viewSubs(data): void {
    const dialogRef = this.dialog.open(SubcriberInfoModalComponent, {
      disableClose: true,
      width: '1000px',
      data: data
    });

    // dialogRef.afterClosed().subscribe(result => {
    //   this.loadData();
    // });
  }

  updateFirmware(data) {
    const dialogRef = this.dialog.open(FirmwareUpdateModelComponent, {
      disableClose: true,
      width: '400px',
      data: data
    });

    dialogRef.afterClosed().subscribe(() => this.loadData());
  }

  selectFirmware(firm) {
    this.firmware = firm;
  }

  getLicenseLabel(license) {
    if (license) {
      return BaseLicensesTypes.filter(l => l.value == license)[0]?.name
    }
  }

  ngOnDestroy(): void {
    this.pageAvailable = false;
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }

    if (this.loadOrganizationSubscription) {
      this.loadOrganizationSubscription.unsubscribe();
    }
    if (this.loadDataDeviceSubscription) {
      this.loadDataDeviceSubscription.unsubscribe();
    }
    if (this.loadDataFirmwareSubscription) {
      this.loadDataFirmwareSubscription.unsubscribe();
    }

    if (this.routeQuerySubscription) {
      this.routeQuerySubscription.unsubscribe();
    }
  }

}
